import { services } from '@/mocks/homeData';

export default function ServicesSection() {
  return (
    <section id="services" className="w-full bg-background-50 py-16 md:py-24">
      <div className="container-content">
        {/* Section header — left-aligned, editorial */}
        <div className="max-w-2xl mb-16 md:mb-20">
          <p className="font-label font-medium text-label-lg text-primary-600 tracking-wide uppercase mb-3">
            What We Do
          </p>
          <h2 className="font-heading text-display-md text-foreground-950 mb-4 text-balance">
            Every space deserves the same standard of clean.
          </h2>
          <p className="text-body-lg text-foreground-600">
            From family homes to corporate headquarters, we bring the same rigour, the same products, and the same people-first approach.
          </p>
        </div>

        {/* Services — asymmetric staggered layout */}
        <div className="space-y-16 md:space-y-24">
          {services.map((service, index) => {
            const isReversed = index % 2 !== 0;

            return (
              <div
                key={service.id}
                id={service.id}
                className={`flex flex-col ${
                  isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'
                } gap-8 lg:gap-12 items-center scroll-mt-24`}
              >
                {/* Image */}
                <div className="w-full lg:w-[55%] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[320px] md:h-[420px] object-cover"
                  />
                </div>

                {/* Text */}
                <div className="w-full lg:w-[45%] lg:py-4">
                  <h3 className="font-heading font-semibold text-heading-lg text-foreground-950 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-body-md text-foreground-600 leading-relaxed mb-4">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}